import {PAGE_PATHS} from 'pages';
import {Regulation} from 'types';

export const createRegulationHref = (id: Regulation['id']): string => {
	return `${PAGE_PATHS.regulations}/${id}`;
};
